import { ApolloClient, InMemoryCache } from '@apollo/client'
// import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries'
import { GRAPHQL_INTERNAL_URL } from '@shared-submodule/sm-constants'
// import { sha256 } from 'crypto-hash'

// const linkChain = createPersistedQueryLink({ sha256, useGETForHashedQueries: true }).concat(
//   new HttpLink({ uri: GRAPHQL_INTERNAL_URL })
// )
const client = new ApolloClient({
  ssrMode: true,
  uri: GRAPHQL_INTERNAL_URL,
  cache: new InMemoryCache()
})

export default async function queryGraphql(query, variables = {}, token, fetchPolicy) {
  try {
    const d = await client.query({
      query,
      variables,
      // fetchPolicy: fetchPolicy || 'cache-first',
      fetchPolicy: 'no-cache',
      context: { headers: { Authorization: token || '' } }
    })
    // console.log(d)
    return d
  } catch (error) {
    console.log({
      msg: error?.message,
      name: query?.definitions?.[0]?.name?.value,
      status: error?.networkError?.statusCode || error?.networkError?.result,
      variables
    })
    // Preserve original error structure
    const graphQLError = new Error()

    // Copy all properties from original error
    Object.assign(graphQLError, error)

    // Add additional useful properties
    graphQLError.message = error?.message || 'GraphQL query failed'
    graphQLError.data = error?.networkError?.result || error?.graphQLErrors?.[0]?.extensions
    graphQLError.status = error?.networkError?.statusCode || 500
    graphQLError.queryName = query?.definitions?.[0]?.name?.value
    graphQLError.variables = variables

    // Preserve original stack trace
    graphQLError.stack = error.stack
    throw graphQLError
  }
  // return client.query({
  //   query,
  //   variables,
  //   // fetchPolicy: fetchPolicy || 'cache-first',
  //   fetchPolicy: 'no-cache',
  //   context: { headers: { Authorization: token || '' } }
  // })
}
